"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UploadedDoc = function UploadedDoc(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 73 85",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M48.73 50.346c-1.577 0-2.896-.511-3.957-1.533-1.06-1.032-1.59-2.36-1.59-3.985 0-1.635.54-2.978 1.62-4.029 1.09-1.06 2.408-1.591 3.955-1.591.954 0 1.84.2 2.657.598.818.39 1.474.92 1.97 1.592l-1.576 1.605c-.817-.983-1.79-1.474-2.92-1.474-.895 0-1.654.311-2.277.934-.622.623-.934 1.406-.934 2.35 0 .925.307 1.694.92 2.307s1.372.92 2.277.92c1.168 0 2.165-.497 2.993-1.49l1.62 1.519c-.506.69-1.182 1.245-2.03 1.664a6.197 6.197 0 0 1-2.729.613ZM30.822 44.813c0-1.566.54-2.89 1.62-3.97 1.09-1.09 2.429-1.635 4.015-1.635 1.586 0 2.92.545 4 1.635 1.09 1.08 1.635 2.399 1.635 3.956s-.54 2.876-1.62 3.956c-1.09 1.07-2.434 1.605-4.03 1.605-1.605 0-2.943-.535-4.014-1.605-1.07-1.07-1.606-2.385-1.606-3.942Zm5.635 3.168c.886 0 1.63-.302 2.233-.905.604-.623.9-1.382.89-2.277-.019-.934-.325-1.698-.919-2.292a2.976 2.976 0 0 0-2.204-.92c-.886 0-1.625.307-2.219.92-.603.623-.905 1.387-.905 2.292 0 .895.302 1.654.905 2.277.604.603 1.343.905 2.219.905ZM24.35 50.185h-4.234V39.398h4.307c1.654 0 2.939.486 3.853 1.46.935.963 1.402 2.277 1.402 3.94 0 1.674-.472 2.988-1.416 3.942-.954.963-2.258 1.445-3.912 1.445Zm-1.825-8.466v6.145h1.927c.876 0 1.547-.292 2.014-.876.477-.593.716-1.328.716-2.204 0-.886-.239-1.615-.716-2.19-.467-.583-1.138-.875-2.014-.875h-1.927Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.791,
    d: "M60.117 28.556v36.237a7.604 7.604 0 0 1-7.604 7.603H20.487a7.604 7.604 0 0 1-7.603-7.603V20.207a7.589 7.589 0 0 1 7.603-7.604h24.086l15.544 15.953Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.791,
    d: "M44.573 12.604v10.01a5.94 5.94 0 0 0 5.943 5.942h9.6L44.574 12.603Z"
  }));
};
var _default = exports["default"] = UploadedDoc;